import { Record } from 'immutable';
import { STORAGE_STATUS } from './actions';

export const InitialState = new Record({
  storageAvailable: null,
});

export default (state = new InitialState(), action) => {
  const { type } = action;

  switch (type) {
    case STORAGE_STATUS: {
      return state.set('storageAvailable', action.available);
    }
    default: {
      return state;
    }
  }
};
